import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store'
import lang from '../lang'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.state.app.lang, // set locale
  messages: lang, // set locale messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/plugins/i18n.js